<template>
    <div :data-color="backgroundColor" :data-active-color="activeColor" class="sidebar">
        <div class="logo">
            <router-link :to="{ path: '/portal/dashboard' }" class="simple-text logo-mini">
                <img :src="logo" alt="" />
            </router-link>
            <router-link :to="{ path: '/portal/dashboard' }" class="simple-text logo-normal">
                {{ title }}
            </router-link>
        </div>
        <div ref="sidebarScrollArea" class="sidebar-wrapper">
            <slot> </slot>
            <ul class="nav">
                <slot name="links">
                    <sidebar-item v-for="(link, index) in sidebarLinks" :key="link.name + index" :link="link">
                        <sidebar-item v-for="(subLink, index) in link.children" :key="subLink.name + index" :link="subLink"> </sidebar-item>
                    </sidebar-item>
                </slot>
            </ul>
        </div>
    </div>
</template>
<script>
import 'perfect-scrollbar/dist/css/perfect-scrollbar.css'
export default {
    props: {
        title: {
            type: String,
            default: 'Verda Support',
            description: 'Sidebar title'
        },
        backgroundColor: {
            type: String,
            default: 'black',
            validator: (value) => {
                let acceptedValues = ['white', 'brown', 'black']
                return acceptedValues.indexOf(value) !== -1
            },
            description: 'Sidebar background color (white|brown|black)'
        },
        activeColor: {
            type: String,
            default: 'success',
            validator: (value) => {
                let acceptedValues = ['primary', 'info', 'success', 'warning', 'danger']
                return acceptedValues.indexOf(value) !== -1
            },
            description: 'Sidebar active text color (primary|info|success|warning|danger)'
        },
        logo: {
            type: String,
            default: '/static/img/verda-favicon.ico',
            description: 'Sidebar Logo'
        },
        sidebarLinks: {
            type: Array,
            default: () => [],
            description: 'Sidebar links. Can be also provided as children components (sidebar-item)'
        },
        autoClose: {
            type: Boolean,
            default: true
        }
    },
    provide() {
        return {
            autoClose: this.autoClose
        }
    },
    mounted() {
        this.initScrollBarAsync()
    },
    beforeDestroy() {
        if (this.$sidebar.showSidebar) {
            this.$sidebar.showSidebar = false
        }
    },
    methods: {
        async initScrollBarAsync() {
            const PerfectScroll = await import('perfect-scrollbar')
            PerfectScroll.initialize(this.$refs.sidebarScrollArea)
        }
    }
}
</script>
<style>
@media (min-width: 992px) {
    .navbar-search-form-mobile,
    .nav-mobile-menu {
        display: none;
    }
}
</style>
